module.exports = __webpack_public_path__ + "static/media/youliang@3x.15bde977.png";